import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'

export function serverErrorHandler (action) {
  return function (error) {
    if (error && error.response && error.response.data && error.response.data.error) {
      const err = error.response.data.error
      if (err.message === 'InternalServerError') {
        err.message = 'Common.InternalServerError'
      } else if (err.validationErrors && err.validationErrors.length) {
        err.message = null
      }
      action(err)
    }
  }
}

export function handleError (dispatch, onErrorAction) {
  return function (error) {
    if (onErrorAction) dispatch(onErrorAction)
    dispatchError(dispatch, error)
  }
}

export function dispatchError (dispatch, error) {
  const msg = (error.response && error.response.data && error.response.data.error && error.response.data.error.message) ||
    'Common.ServerInternalError'
  dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.alert,
    content: msg
  }))
}



// WEBPACK FOOTER //
// ./src/utils/serverErrorHandler.js